import type { ReactNode } from 'react';

/**
 * Platform-style card container. Mirrors the `.card` class in
 * apps/web/src/app/globals.css: surface bg + 1px border + 0.75rem radius
 * + subtle shadow. Designed to feel native inside Claude/ChatGPT.
 */
export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`bg-surface border border-border rounded-card shadow-sm overflow-hidden ${className}`}>
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, right }: { title: string; subtitle?: string; right?: ReactNode }) {
  return (
    <div className="px-5 py-4 border-b border-border flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h2 className="text-base font-semibold text-primary leading-tight truncate">{title}</h2>
        {subtitle && <p className="text-xs text-muted mt-1 truncate">{subtitle}</p>}
      </div>
      {right && <div className="flex-shrink-0">{right}</div>}
    </div>
  );
}

export function CardBody({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`px-5 py-4 ${className}`}>{children}</div>;
}
